import mixpanel from 'mixpanel-browser';
import {
  MAX_CHARACTERS,
  MAX_SEGMENTS,
} from '../../blocks/VideoScriptEditorBlock';
import { getStaticAssetUrl } from '../../helper/getStaticAssetUrl';
import { useSelector } from 'react-redux';

const scriptImg = getStaticAssetUrl('onboarding-video-script.png');

export const WelcomeVideoScript = ({ videoScript, setVideoScript }) => {
  const userId = useSelector((st) => st.auth?.user?.userId);

  return (
    <div className="flex max-w-full min-w-0 flex-1 font-roboto gap-3 p-5 bg-purple bg-opacity-[5%] rounded-[9px] h-[200px] tall:h-[350px]">
      <img src={scriptImg} className="object-contain h-full" alt="" />
      <div className="flex flex-col text-black grow gap-2.5">
        <div className="flex flex-col">
          <span className="text-lg font-bold">Video Script</span>
          <span className="text-[#6D6D6D] text-xs">
            Start Editing your First Video Script
          </span>
        </div>
        <textarea
          className="resize-none w-full h-full outline-none border border-[#EBEBEB] p-[15px] gray-scrollbar px-2 text-xs rounded-[9px]"
          value={videoScript}
          onChange={(event) => {
            const newValue = event.currentTarget.value
              .split('\n\n')
              .slice(0, MAX_SEGMENTS)
              .join('\n\n');
            setVideoScript(newValue);
          }}
          onKeyDown={(event) => {
            if (
              event.key === 'Enter' &&
              (videoScript || '').split('\n\n').length >= MAX_SEGMENTS
            ) {
              event.preventDefault();
            }
          }}
          maxLength={MAX_CHARACTERS}
          onBlur={() => {
            mixpanel.track('Onboarding: Default Video Script Changed', {
              distinct_id: userId,
            });
          }}
        ></textarea>
      </div>
    </div>
  );
};
